// Central data source for Delventure services.
// Five focused practice areas — no regulated execution offerings.

export const CONSULTATIONS = [
  {
    slug: "digital-marketing",
    n: "01",
    category: "Growth",
    title: "Digital Marketing",
    tagline: "Growth, engineered by intelligence.",
    body:
      "Performance marketing, SEO, content, and AI-personalised campaigns that compound over time. We engineer growth funnels that learn from every click.",
    bullets: [
      "Performance Marketing (Meta, Google, LinkedIn, TikTok)",
      "SEO & Content Engines",
      "AI Personalisation & Lifecycle CRM",
      "Conversion Rate Optimisation",
      "Attribution & Analytics",
    ],
    deliverables: [
      "Channel mix & budget plan",
      "Always-on creative system",
      "Weekly performance dashboard",
      "Quarterly growth review",
    ],
    who: "Founders, CMOs, and growth leads at scaling teams.",
  },
  {
    slug: "web-and-app-development",
    n: "02",
    category: "Build",
    title: "Web & App Development",
    tagline: "Products people feel.",
    body:
      "Design-led web and mobile builds that are fast, beautiful, and built to convert. From marketing sites to multi-region SaaS platforms.",
    bullets: [
      "Marketing & Brand Sites",
      "SaaS Platforms",
      "Native iOS / Android & PWA",
      "Design Systems",
      "Conversion UX",
    ],
    deliverables: [
      "Discovery & spec",
      "Design system",
      "Production launch",
      "Ongoing iteration",
    ],
    who: "Product teams launching v1 and businesses replatforming.",
  },
  {
    slug: "automation-and-ai-systems",
    n: "03",
    category: "Intelligence",
    title: "Automation & AI Systems",
    tagline: "Your business, on autopilot.",
    body:
      "Workflow automation, AI agents, and integrations that remove manual work and scale output without scaling headcount. From production AI assistants to RPA, your business becomes self-running.",
    bullets: [
      "AI Agents & Copilots",
      "Workflow Automation (n8n, Make, custom)",
      "RAG & Knowledge Pipelines",
      "Integrations & RPA",
      "Guardrails & Observability",
    ],
    deliverables: [
      "Process audit & automation blueprint",
      "Production-ready agents & workflows",
      "Monitoring & evaluation suite",
      "Runbooks & team enablement",
    ],
    who: "Operations, product, and CTO teams ready to move beyond pilots.",
  },
  {
    slug: "it-and-infrastructure",
    n: "04",
    category: "Foundations",
    title: "IT & Infrastructure",
    tagline: "Foundations that never flinch.",
    body:
      "Managed IT, cloud, security, and support that scale quietly in the background while your business grows in the foreground.",
    bullets: [
      "Cloud & DevOps (AWS, GCP, Azure)",
      "Security & SOC2 Readiness",
      "Managed IT & Endpoint Support",
      "Identity & Access (SSO, MFA)",
      "Observability & Incident Response",
    ],
    deliverables: [
      "Infrastructure assessment",
      "Hardening roadmap",
      "24/7 managed support",
      "Quarterly resilience review",
    ],
    who: "Scaling companies that have outgrown ad-hoc IT.",
  },
  {
    slug: "business-consultancy",
    n: "05",
    category: "Advisory",
    title: "Business Consultancy",
    tagline: "Strategy with a build button.",
    body:
      "Growth, digital transformation, and go-to-market consultancy that ships — not just slides. We pair strategic thinking with our build capability so recommendations turn into reality.",
    bullets: [
      "Growth Strategy",
      "Digital Transformation",
      "Go-to-Market Planning",
      "Operating Model Design",
      "Founder & Leadership Advisory",
    ],
    deliverables: [
      "Strategic diagnosis",
      "12-month roadmap",
      "Implementation support",
      "Quarterly business review",
    ],
    who: "CEOs and leadership teams looking for clarity and momentum.",
  },
];

export const findConsultation = (slug) => CONSULTATIONS.find((c) => c.slug === slug);
